<!--  -->
<template>
    <div class='container'>
        <div class="map_wrapper box box_v">
            <div class="number_wrapper box box_between">
                <div class="numberbg box_f1">
                    <div class="title">总事项</div>
                    <div class="subtitle" v-if="itemCount">{{itemCount}}<span style="font-size:13px">项</span></div>
                </div>
                <div class="numberbg box_f1">
                    <div class="title">总办理量</div>
                    <div class="subtitle" v-if="handleCount">{{handleCount}}<span style="font-size:13px">件</span></div>
                </div>
                <div class="numberbg box_f1">
                    <div class="title">总访问量</div>
                    <div class="subtitle"  v-if="accessCount">{{accessCount}}<span style="font-size:13px">人次</span></div>
                </div>
                <div class="numberbg box_f1">
                    <div class="title">用户数</div>
                    <div class="subtitle">
                        <div class="subtitle" v-if="userCount">{{userCount}}<span style="font-size:13px">人</span></div>
                    </div>
                </div>
            </div>
            <div class="map box_f1"></div>
        </div>
        
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            itemCount:0,
            handleCount:0,
            accessCount:0,
            userCount:0,
            
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.overview).then(res=>{
                //this.itemCount = res.newPrimaryKeys.itemCount //总事项数
                this.itemCount = 2013
                this.handleCount = res.newPrimaryKeys.handleCount //总办理量
                this.accessCount = res.newPrimaryKeys.accessCount  //总访问量
                this.userCount = res.newPrimaryKeys.userCount //用户数
                console.log(this.userCount)

            }).catch(e=>console.log(e))
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
       
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
         this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    
    padding:0 20px 10px 20px;
    width:100%;
    height:100%;
}
.map_wrapper{
    width:100%;
    height:100%;
    background-image: url('../../../../assets/images/monitorpy/9.png');
    background-size: 100% 100%;
    padding:20px;
    .number_wrapper{
        // position:absolute;
        // top:20px;
        // left:40px;
        // right:40px;
        //margin:20px 40px;
        height:88px;

        .numberbg{
            margin:0 10px;
            width:100%;
            height:100%;
            background-image: url('../../../../assets/images/monitorpy/numberbg.png');
            background-size: 100% 100%;
            
        }
        .title{
            font-size: 16px;
            color: #00EFE1;
            line-height: 45px;
            text-align: center;
        }
        .subtitle{
            font-size: 26px;
            font-style: italic;
            color: #09D4FF;
            text-align: center;
            background: linear-gradient(180deg, #00FFCC 0%, #00EAFF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

        }
    }
    .map{
        margin-top: 20px;
        width: 100%;
        height: 100%;
        background-image: url('../../../../assets/images/monitorpy/map.png');
        background-size: 100% 100%;
    }
}

</style>